export const slashSymbol = ['／', '/', '、'];
export const isSlashSymbol = (text = '') => slashSymbol.includes(text);
